import Config from '../config'
import axios from 'axios'

const payByLink = function (URL, data) {
  if (!URL) {
    URL = Config.payments.payByLink.link.urls.host
    return axios.create({
      baseURL: URL,
      headers: {
        'Content-Type': 'application/json'
      }
    }).post(URL, data)
  }
}
export default payByLink
